export default "__VITE_ASSET__Be029Cmc__"